/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest,
  PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
  PostApiV1CourseregistrationEnrollmentManagementStatus400,
  PostApiV1CourseregistrationEnrollmentManagementStatus401,
  PostApiV1CourseregistrationEnrollmentManagementStatus500,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentManagementStatus.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1CourseregistrationEnrollmentManagementStatus } from "../../clients/courseRegistrationEnrollmentController/postApiV1CourseregistrationEnrollmentManagementStatus.ts";

export const postApiV1CourseregistrationEnrollmentManagementStatusMutationKey =
  () =>
    [
      { url: "/api/v1/courseregistration/enrollment/management-status" },
    ] as const;

export type PostApiV1CourseregistrationEnrollmentManagementStatusMutationKey =
  ReturnType<
    typeof postApiV1CourseregistrationEnrollmentManagementStatusMutationKey
  >;

export function postApiV1CourseregistrationEnrollmentManagementStatusMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1CourseregistrationEnrollmentManagementStatusMutationKey();
  return mutationOptions<
    PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentManagementStatus400
      | PostApiV1CourseregistrationEnrollmentManagementStatus401
      | PostApiV1CourseregistrationEnrollmentManagementStatus500
    >,
    {
      data?: PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1CourseregistrationEnrollmentManagementStatus(
        data,
        config,
      );
    },
  });
}

/**
 * @description Altera o status de matrícula com base nas opções de gestão disponíveis. Para status de cancelamento (Cancelado, Cancelado em Inscrição, Rejeitado), os campos StatusReasonId, SubStatusReasonId e Observation são obrigatórios. Cancela parcelas em aberto e vínculo de bolsa quando aplicável. **(Requer Authorization para autenticação)**
 * @summary Altera o status de gestão de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/management-status}
 */
export function usePostApiV1CourseregistrationEnrollmentManagementStatus<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationEnrollmentManagementStatus400
        | PostApiV1CourseregistrationEnrollmentManagementStatus401
        | PostApiV1CourseregistrationEnrollmentManagementStatus500
      >,
      {
        data?: PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1CourseregistrationEnrollmentManagementStatusMutationKey();

  const baseOptions =
    postApiV1CourseregistrationEnrollmentManagementStatusMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
      ResponseErrorConfig<
        | PostApiV1CourseregistrationEnrollmentManagementStatus400
        | PostApiV1CourseregistrationEnrollmentManagementStatus401
        | PostApiV1CourseregistrationEnrollmentManagementStatus500
      >,
      {
        data?: PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentManagementStatus400
      | PostApiV1CourseregistrationEnrollmentManagementStatus401
      | PostApiV1CourseregistrationEnrollmentManagementStatus500
    >,
    {
      data?: PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationEnrollmentManagementStatus400
      | PostApiV1CourseregistrationEnrollmentManagementStatus401
      | PostApiV1CourseregistrationEnrollmentManagementStatus500
    >,
    {
      data?: PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest;
    },
    TContext
  >;
}
